import { __assign, __read, __spreadArray } from "tslib";
var ApplePayNetworksByVersion = {
    amex: 1,
    bancomat: 14,
    bancontact: 14,
    cartesBancaires: 4,
    chinaUnionPay: 1,
    dankort: 13,
    discover: 1,
    eftpos: 4,
    electron: 4,
    elo: 5,
    girocard: 11,
    interac: 1,
    jcb: 2,
    mada: 5,
    maestro: 4,
    masterCard: 1,
    mir: 11,
    privateLabel: 1,
    visa: 1,
    vPay: 4
};
var applePayNetworks = new Set(Object.keys(ApplePayNetworksByVersion));
var isApplePayNetwork = function (network) {
    return applePayNetworks.has(network);
};
export var reduceNetworksToSupported = function (version, request) {
    var allNetworks = request.supportedNetworks.length > 0
        ? request.supportedNetworks
        : __spreadArray([], __read(applePayNetworks), false);
    var supportedNetworks = allNetworks
        .filter(isApplePayNetwork)
        .filter(function (network) { return ApplePayNetworksByVersion[network] <= version; });
    return __assign(__assign({}, request), { supportedNetworks: supportedNetworks });
};
